import { render, staticRenderFns } from "./BaseDebug.vue?vue&type=template&id=7a8f8974&"
import script from "./BaseDebug.vue?vue&type=script&lang=ts&"
export * from "./BaseDebug.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports